/**
 * Resolves service type code to the actual DB table name.
 * Standard services (agreements, tickets, leads, payments) use code as-is.
 * Entity-engine services use svc_ prefix (e.g. pp_certificates → svc_pp_certificates).
 */
const STANDARD_TABLES = new Set(['agreements', 'tickets', 'leads', 'payments']);

export function resolveServiceTableName(serviceType: string): string {
  if (serviceType.startsWith('svc_')) return serviceType;
  if (STANDARD_TABLES.has(serviceType)) return serviceType;
  return `svc_${serviceType}`;
}
